import ResultsWrapper from '@/views/ResultsWrapper.vue'
import { USER_ROLES } from '@/config/config-app-models'
import { guestGuard } from '@/router/auth-guards'
import type { NavigationGuard } from 'vue-router'

const envGuard: NavigationGuard = (to, from, next) => {
  const env = to.params.env as string
  const envLower = env?.toLowerCase()
  // if (envLower && ['ea', 'aai', 'ani'].includes(envLower)) {
  //   next()
  // } else {
  //   // Redirect to the same route with env set to 'ea'
  //   next({ name: to.name as string, params: { ...to.params, env: 'ea' } })
  // }
  //  for now we're going to disable this and just allow any environment.
  next()
}

export const mainRoutes = [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: 'results/:env?/:id',
    name: 'results',
    component: ResultsWrapper,
    beforeEnter: envGuard
  },
  {
    path: 'secure-results/:env?/:id',
    name: 'secure-results',
    component: ResultsWrapper,
    meta: {
      requiresAuth: true,
      roles: [USER_ROLES.admin]
    },
    beforeEnter: envGuard
  },
  {
    path: 'admin-results/:env?/:id',
    name: 'admin-results',
    component: ResultsWrapper,
    meta: {
      requiresAuth: true,
      roles: [USER_ROLES.admin]
    },
    beforeEnter: envGuard
  },
  {
    path: 'about',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: 'admin',
    name: 'server-admin',
    component: () => import('@/views/AdminDashboardView.vue'),
    meta: {
      requiresAuth: true,
      roles: [USER_ROLES.admin]
    }
  },
  {
    path: 'login',
    name: 'login',
    component: () => import('@/components/results/auth/LoginPage.vue'),
    beforeEnter: guestGuard
  },
  {
    path: 'unauthorized',
    name: 'unauthorized',
    component: () => import('@/components/results/auth/UnauthorizedPage.vue')
  },
  {
    path: 'auth-success',
    name: 'auth-success',
    component: () => import('@/components/results/auth/AuthSuccess.vue')
  },
  {
    path: 'auth-test',
    name: 'auth-test',
    component: () => import('@/components/results/auth/AuthSuccessTest.vue')
  }
]
